import camille from "../../assets/cast/camille.png";
import isaiah from "../../assets/cast/isaiah.png";
import jake from "../../assets/cast/jake.png";
import malcolm from "../../assets/cast/malcolm.png";
import { DAY, SlabButton } from "./day";
import { Logo } from "./Nav";
import { StoreBadges } from "./StoreBadges";
import { goToHero } from "./shared";

const CAST = [isaiah, jake, camille, malcolm];

export function FinalCta() {
  return (
    <section aria-label="Start learning" className="relative overflow-hidden bg-white px-4 pt-24 sm:px-6 sm:pt-32">
      <div className="relative mx-auto flex max-w-2xl flex-col items-center text-center">
        <h2 className="text-[2.1rem] leading-[1.1] font-black tracking-tight text-[#1C1A27] sm:text-5xl">What do you want to learn?</h2>
        <p className="mt-4 max-w-lg text-[17px] leading-relaxed text-[#6B6780] sm:text-lg">Say it in one sentence. Your first lesson is ready in about a minute.</p>
        <SlabButton onClick={goToHero} className="mt-8 h-[58px] px-10 text-base">
          Start learning
        </SlabButton>
        <p className="mt-8 text-xs font-extrabold text-[#8A8698]">or get the app</p>
        <div className="mt-3 flex w-full justify-center">
          <StoreBadges center light />
        </div>
      </div>
      {/* The cast on the course map's grass. */}
      <div aria-hidden className="relative mx-auto mt-14 h-[200px] max-w-3xl sm:h-[260px]">
        <div className="absolute inset-x-[-50vw] bottom-0 h-[58px]" style={{ background: DAY.ground }} />
        <div className="absolute inset-x-0 bottom-[22px] flex items-end justify-center gap-[3%]">
          {CAST.map((src, i) => (
            <img key={src} src={src} alt="" className="h-[170px] w-auto sm:h-[230px]" style={{ marginBottom: i % 2 ? 6 : 0 }} />
          ))}
        </div>
      </div>
    </section>
  );
}

export function Footer() {
  return (
    <footer className="px-4 py-12 sm:px-6" style={{ background: DAY.ground }}>
      <div className="mx-auto flex max-w-6xl flex-col gap-10 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <Logo dark />
          <p className="mt-3 text-sm leading-relaxed font-semibold text-[#3E5A2A]">Personal courses for wherever you’re headed, one short lesson at a time.</p>
          <div className="mt-5">
            <StoreBadges compact light />
          </div>
        </div>
        <nav aria-label="Footer" className="grid grid-cols-2 gap-x-12 gap-y-2.5 text-sm font-bold text-[#3E5A2A]">
          <a href="#how" className="hover:text-[#1C1A27]">How it works</a>
          <a href="#lesson" className="hover:text-[#1C1A27]">Lessons</a>
          <a href="#course" className="hover:text-[#1C1A27]">Course map</a>
          <a href="#research" className="hover:text-[#1C1A27]">Research</a>
          <a href="#who" className="hover:text-[#1C1A27]">Who it’s for</a>
          <a href="#pricing" className="hover:text-[#1C1A27]">Pricing</a>
          <a href="#faq" className="hover:text-[#1C1A27]">FAQ</a>
        </nav>
      </div>
      <p className="mx-auto mt-10 max-w-6xl text-xs font-bold text-[#3E5A2A]/70">© {new Date().getFullYear()} LearnAnything</p>
    </footer>
  );
}
